<topbar> <h1 topbar-title>Check Submissions</h1> </topbar>

<page pTitle="Pending Reconciliations">
    <card>
        <card-section>
            <stack pDistribution="trailing">
                <form-field>
                    <custom-date-time-picker
                        name="site_check_date"
                        id="site_check_dat"
                        [(ngModel)]="dateSelected"
                        (dateChanged)="onDateChanged($event)"
                        hideTimePicker="true"
                    ></custom-date-time-picker>
                </form-field>
                <form-field>
                    <mat-select
                        class="btn__select"
                        name="status"
                        [(ngModel)]="locationSelected"
                        (selectionChange)="onSelectionChanged($event.value)"
                    >
                        <mat-option
                            [value]="location"
                            *ngFor="let location of locations"
                        >
                            {{ location }}
                        </mat-option>
                    </mat-select>
                </form-field>
            </stack>
        </card-section>
        <card-section>
            <item-list  [pLoading]="loading > 0" [pDataSource]="uncheckedVehicles">
                <item-list-item *pItemListDef="let vehicle" [pItem]="vehicle" (click)="redirectToReconciliation(vehicle)">
                    <stack pAlignment="center">
                        <span class="vehicle-plate">
                            {{ vehicle }}
                        </span>


                        
                    </stack>
                </item-list-item>

            </item-list>
        </card-section>
    </card>
</page>